import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\Pricing\PricingRuleController::index
* @see app/Http/Controllers/Admin/Pricing/PricingRuleController.php:32
* @route '/pricing/rules'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/pricing/rules',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingRuleController::index
* @see app/Http/Controllers/Admin/Pricing/PricingRuleController.php:32
* @route '/pricing/rules'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingRuleController::index
* @see app/Http/Controllers/Admin/Pricing/PricingRuleController.php:32
* @route '/pricing/rules'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingRuleController::index
* @see app/Http/Controllers/Admin/Pricing/PricingRuleController.php:32
* @route '/pricing/rules'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingRuleController::index
* @see app/Http/Controllers/Admin/Pricing/PricingRuleController.php:32
* @route '/pricing/rules'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingRuleController::index
* @see app/Http/Controllers/Admin/Pricing/PricingRuleController.php:32
* @route '/pricing/rules'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingRuleController::index
* @see app/Http/Controllers/Admin/Pricing/PricingRuleController.php:32
* @route '/pricing/rules'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingRuleController::create
* @see app/Http/Controllers/Admin/Pricing/PricingRuleController.php:61
* @route '/pricing/rules/create'
*/
export const create = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

create.definition = {
    methods: ["get","head"],
    url: '/pricing/rules/create',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingRuleController::create
* @see app/Http/Controllers/Admin/Pricing/PricingRuleController.php:61
* @route '/pricing/rules/create'
*/
create.url = (options?: RouteQueryOptions) => {
    return create.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingRuleController::create
* @see app/Http/Controllers/Admin/Pricing/PricingRuleController.php:61
* @route '/pricing/rules/create'
*/
create.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingRuleController::create
* @see app/Http/Controllers/Admin/Pricing/PricingRuleController.php:61
* @route '/pricing/rules/create'
*/
create.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: create.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingRuleController::create
* @see app/Http/Controllers/Admin/Pricing/PricingRuleController.php:61
* @route '/pricing/rules/create'
*/
const createForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingRuleController::create
* @see app/Http/Controllers/Admin/Pricing/PricingRuleController.php:61
* @route '/pricing/rules/create'
*/
createForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingRuleController::create
* @see app/Http/Controllers/Admin/Pricing/PricingRuleController.php:61
* @route '/pricing/rules/create'
*/
createForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

create.form = createForm

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingRuleController::preview
* @see app/Http/Controllers/Admin/Pricing/PricingRuleController.php:147
* @route '/pricing/rules/preview'
*/
export const preview = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: preview.url(options),
    method: 'get',
})

preview.definition = {
    methods: ["get","head"],
    url: '/pricing/rules/preview',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingRuleController::preview
* @see app/Http/Controllers/Admin/Pricing/PricingRuleController.php:147
* @route '/pricing/rules/preview'
*/
preview.url = (options?: RouteQueryOptions) => {
    return preview.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingRuleController::preview
* @see app/Http/Controllers/Admin/Pricing/PricingRuleController.php:147
* @route '/pricing/rules/preview'
*/
preview.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: preview.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingRuleController::preview
* @see app/Http/Controllers/Admin/Pricing/PricingRuleController.php:147
* @route '/pricing/rules/preview'
*/
preview.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: preview.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingRuleController::preview
* @see app/Http/Controllers/Admin/Pricing/PricingRuleController.php:147
* @route '/pricing/rules/preview'
*/
const previewForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: preview.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingRuleController::preview
* @see app/Http/Controllers/Admin/Pricing/PricingRuleController.php:147
* @route '/pricing/rules/preview'
*/
previewForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: preview.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingRuleController::preview
* @see app/Http/Controllers/Admin/Pricing/PricingRuleController.php:147
* @route '/pricing/rules/preview'
*/
previewForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: preview.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

preview.form = previewForm

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingRuleController::apply
* @see app/Http/Controllers/Admin/Pricing/PricingRuleController.php:132
* @route '/pricing/rules/apply'
*/
export const apply = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: apply.url(options),
    method: 'post',
})

apply.definition = {
    methods: ["post"],
    url: '/pricing/rules/apply',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingRuleController::apply
* @see app/Http/Controllers/Admin/Pricing/PricingRuleController.php:132
* @route '/pricing/rules/apply'
*/
apply.url = (options?: RouteQueryOptions) => {
    return apply.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingRuleController::apply
* @see app/Http/Controllers/Admin/Pricing/PricingRuleController.php:132
* @route '/pricing/rules/apply'
*/
apply.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: apply.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingRuleController::apply
* @see app/Http/Controllers/Admin/Pricing/PricingRuleController.php:132
* @route '/pricing/rules/apply'
*/
const applyForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: apply.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingRuleController::apply
* @see app/Http/Controllers/Admin/Pricing/PricingRuleController.php:132
* @route '/pricing/rules/apply'
*/
applyForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: apply.url(options),
    method: 'post',
})

apply.form = applyForm

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingRuleController::autoApply
* @see app/Http/Controllers/Admin/Pricing/PricingRuleController.php:117
* @route '/pricing/rules/auto-apply'
*/
export const autoApply = (options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: autoApply.url(options),
    method: 'patch',
})

autoApply.definition = {
    methods: ["patch"],
    url: '/pricing/rules/auto-apply',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingRuleController::autoApply
* @see app/Http/Controllers/Admin/Pricing/PricingRuleController.php:117
* @route '/pricing/rules/auto-apply'
*/
autoApply.url = (options?: RouteQueryOptions) => {
    return autoApply.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingRuleController::autoApply
* @see app/Http/Controllers/Admin/Pricing/PricingRuleController.php:117
* @route '/pricing/rules/auto-apply'
*/
autoApply.patch = (options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: autoApply.url(options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingRuleController::autoApply
* @see app/Http/Controllers/Admin/Pricing/PricingRuleController.php:117
* @route '/pricing/rules/auto-apply'
*/
const autoApplyForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: autoApply.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingRuleController::autoApply
* @see app/Http/Controllers/Admin/Pricing/PricingRuleController.php:117
* @route '/pricing/rules/auto-apply'
*/
autoApplyForm.patch = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: autoApply.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

autoApply.form = autoApplyForm

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingRuleController::store
* @see app/Http/Controllers/Admin/Pricing/PricingRuleController.php:73
* @route '/pricing/rules'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/pricing/rules',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingRuleController::store
* @see app/Http/Controllers/Admin/Pricing/PricingRuleController.php:73
* @route '/pricing/rules'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingRuleController::store
* @see app/Http/Controllers/Admin/Pricing/PricingRuleController.php:73
* @route '/pricing/rules'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingRuleController::store
* @see app/Http/Controllers/Admin/Pricing/PricingRuleController.php:73
* @route '/pricing/rules'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingRuleController::store
* @see app/Http/Controllers/Admin/Pricing/PricingRuleController.php:73
* @route '/pricing/rules'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingRuleController::edit
* @see app/Http/Controllers/Admin/Pricing/PricingRuleController.php:66
* @route '/pricing/rules/{rule}/edit'
*/
export const edit = (args: { rule: string | { id: string } } | [rule: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

edit.definition = {
    methods: ["get","head"],
    url: '/pricing/rules/{rule}/edit',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingRuleController::edit
* @see app/Http/Controllers/Admin/Pricing/PricingRuleController.php:66
* @route '/pricing/rules/{rule}/edit'
*/
edit.url = (args: { rule: string | { id: string } } | [rule: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { rule: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { rule: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            rule: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        rule: typeof args.rule === 'object'
        ? args.rule.id
        : args.rule,
    }

    return edit.definition.url
            .replace('{rule}', parsedArgs.rule.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingRuleController::edit
* @see app/Http/Controllers/Admin/Pricing/PricingRuleController.php:66
* @route '/pricing/rules/{rule}/edit'
*/
edit.get = (args: { rule: string | { id: string } } | [rule: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingRuleController::edit
* @see app/Http/Controllers/Admin/Pricing/PricingRuleController.php:66
* @route '/pricing/rules/{rule}/edit'
*/
edit.head = (args: { rule: string | { id: string } } | [rule: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: edit.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingRuleController::edit
* @see app/Http/Controllers/Admin/Pricing/PricingRuleController.php:66
* @route '/pricing/rules/{rule}/edit'
*/
const editForm = (args: { rule: string | { id: string } } | [rule: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingRuleController::edit
* @see app/Http/Controllers/Admin/Pricing/PricingRuleController.php:66
* @route '/pricing/rules/{rule}/edit'
*/
editForm.get = (args: { rule: string | { id: string } } | [rule: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingRuleController::edit
* @see app/Http/Controllers/Admin/Pricing/PricingRuleController.php:66
* @route '/pricing/rules/{rule}/edit'
*/
editForm.head = (args: { rule: string | { id: string } } | [rule: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

edit.form = editForm

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingRuleController::update
* @see app/Http/Controllers/Admin/Pricing/PricingRuleController.php:83
* @route '/pricing/rules/{rule}'
*/
export const update = (args: { rule: string | { id: string } } | [rule: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/pricing/rules/{rule}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingRuleController::update
* @see app/Http/Controllers/Admin/Pricing/PricingRuleController.php:83
* @route '/pricing/rules/{rule}'
*/
update.url = (args: { rule: string | { id: string } } | [rule: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { rule: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { rule: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            rule: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        rule: typeof args.rule === 'object'
        ? args.rule.id
        : args.rule,
    }

    return update.definition.url
            .replace('{rule}', parsedArgs.rule.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingRuleController::update
* @see app/Http/Controllers/Admin/Pricing/PricingRuleController.php:83
* @route '/pricing/rules/{rule}'
*/
update.put = (args: { rule: string | { id: string } } | [rule: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingRuleController::update
* @see app/Http/Controllers/Admin/Pricing/PricingRuleController.php:83
* @route '/pricing/rules/{rule}'
*/
const updateForm = (args: { rule: string | { id: string } } | [rule: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingRuleController::update
* @see app/Http/Controllers/Admin/Pricing/PricingRuleController.php:83
* @route '/pricing/rules/{rule}'
*/
updateForm.put = (args: { rule: string | { id: string } } | [rule: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingRuleController::toggleActive
* @see app/Http/Controllers/Admin/Pricing/PricingRuleController.php:95
* @route '/pricing/rules/{rule}/active'
*/
export const toggleActive = (args: { rule: string | { id: string } } | [rule: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: toggleActive.url(args, options),
    method: 'patch',
})

toggleActive.definition = {
    methods: ["patch"],
    url: '/pricing/rules/{rule}/active',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingRuleController::toggleActive
* @see app/Http/Controllers/Admin/Pricing/PricingRuleController.php:95
* @route '/pricing/rules/{rule}/active'
*/
toggleActive.url = (args: { rule: string | { id: string } } | [rule: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { rule: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { rule: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            rule: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        rule: typeof args.rule === 'object'
        ? args.rule.id
        : args.rule,
    }

    return toggleActive.definition.url
            .replace('{rule}', parsedArgs.rule.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingRuleController::toggleActive
* @see app/Http/Controllers/Admin/Pricing/PricingRuleController.php:95
* @route '/pricing/rules/{rule}/active'
*/
toggleActive.patch = (args: { rule: string | { id: string } } | [rule: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: toggleActive.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingRuleController::toggleActive
* @see app/Http/Controllers/Admin/Pricing/PricingRuleController.php:95
* @route '/pricing/rules/{rule}/active'
*/
const toggleActiveForm = (args: { rule: string | { id: string } } | [rule: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: toggleActive.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingRuleController::toggleActive
* @see app/Http/Controllers/Admin/Pricing/PricingRuleController.php:95
* @route '/pricing/rules/{rule}/active'
*/
toggleActiveForm.patch = (args: { rule: string | { id: string } } | [rule: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: toggleActive.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

toggleActive.form = toggleActiveForm

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingRuleController::destroy
* @see app/Http/Controllers/Admin/Pricing/PricingRuleController.php:106
* @route '/pricing/rules/{rule}'
*/
export const destroy = (args: { rule: string | { id: string } } | [rule: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/pricing/rules/{rule}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingRuleController::destroy
* @see app/Http/Controllers/Admin/Pricing/PricingRuleController.php:106
* @route '/pricing/rules/{rule}'
*/
destroy.url = (args: { rule: string | { id: string } } | [rule: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { rule: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { rule: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            rule: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        rule: typeof args.rule === 'object'
        ? args.rule.id
        : args.rule,
    }

    return destroy.definition.url
            .replace('{rule}', parsedArgs.rule.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingRuleController::destroy
* @see app/Http/Controllers/Admin/Pricing/PricingRuleController.php:106
* @route '/pricing/rules/{rule}'
*/
destroy.delete = (args: { rule: string | { id: string } } | [rule: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingRuleController::destroy
* @see app/Http/Controllers/Admin/Pricing/PricingRuleController.php:106
* @route '/pricing/rules/{rule}'
*/
const destroyForm = (args: { rule: string | { id: string } } | [rule: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingRuleController::destroy
* @see app/Http/Controllers/Admin/Pricing/PricingRuleController.php:106
* @route '/pricing/rules/{rule}'
*/
destroyForm.delete = (args: { rule: string | { id: string } } | [rule: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const rules = {
    index: Object.assign(index, index),
    create: Object.assign(create, create),
    preview: Object.assign(preview, preview),
    apply: Object.assign(apply, apply),
    autoApply: Object.assign(autoApply, autoApply),
    store: Object.assign(store, store),
    edit: Object.assign(edit, edit),
    update: Object.assign(update, update),
    toggleActive: Object.assign(toggleActive, toggleActive),
    destroy: Object.assign(destroy, destroy),
}

export default rules